import type { ContextIdentifierProvider } from '@atlaskit/editor-common/provider-factory/context-identifier-provider';

export const COPY_PASTE_MACRO_PARAM = 'aiManagedObjectCopyPaste';

export type ClipboardOperation = 'copy' | 'cut';

export type CopyPasteMarker = {
	operation: ClipboardOperation;
	sourceAiManagedObjectId: string;
	sourcePageUrl?: string;
	sourceReferenceObjectAri?: string;
};

export type CreateCopyPasteIdentityArgs = {
	cloudId?: string;
	contentType?: string;
	getContextIdentifierProvider?: () => ContextIdentifierProvider | undefined;
};

export type PendingArchivedRemoval = {
	aiManagedObjectId: string;
	archiveError?: unknown;
	archiveFailed?: true;
	archivePromise?: Promise<void>;
};

export type AgentManagedNodeInfo = {
	aiManagedObjectId?: string;
	localId: string;
};
